document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.bdr-color-swatch').forEach(function (swatch) {
    swatch.style.backgroundColor = swatch.dataset.hex;
  });
});

document.addEventListener('click', function (e) {
  const swatch = e.target.closest('.bdr-color-swatch');
  if (!swatch) return;

  const picker = swatch.closest('.bdr-color-picker');
  picker.querySelectorAll('.bdr-color-swatch').forEach(s => s.classList.remove('is-selected'));
  swatch.classList.add('is-selected');
  picker.classList.remove('bdr-color-picker--errore');

  const input = picker.querySelector('input[type="hidden"]');
  if (input) {
    input.value = swatch.dataset.color;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  // il nome della tinta va accanto all'etichetta del campo
  const campo = picker.closest('.product__personalization-field');
  const scelto = campo && campo.querySelector('.product__personalization-scelto');
  if (scelto) scelto.textContent = swatch.dataset.color;
});

document.addEventListener('submit', function (e) {
  const pickers = e.target.querySelectorAll('.bdr-color-picker[data-required]');
  let errore = false;
  pickers.forEach(picker => {
    const input = picker.querySelector('input[type="hidden"]');
    if (input && !input.value) {
      picker.classList.add('bdr-color-picker--errore');
      if (!errore) {
        picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
        errore = true;
      }
    }
  });
  if (errore) e.preventDefault();
}, true);

/* Campi obbligatori vuoti: al posto del fumetto nativo (che teletrasporta
   la pagina sul campo), anello accento sul campo (nessuno spostamento di
   layout) e UN solo messaggio nel contenitore errori di Dawn sotto al
   bottone, dove l'utente sta guardando. */
function bdrMostraErroreForm(form, testo) {
  const wrapper = form.closest('product-form') || form.parentElement;
  const zona = wrapper.querySelector('.product-form__error-message-wrapper');
  if (!zona) return;
  const msg = zona.querySelector('.product-form__error-message');
  if (msg) msg.textContent = testo;
  zona.removeAttribute('hidden');
}

function bdrNascondiErroreForm(form) {
  const wrapper = form.closest('product-form') || form.parentElement;
  const zona = wrapper ? wrapper.querySelector('.product-form__error-message-wrapper') : null;
  if (zona) zona.setAttribute('hidden', '');
}

document.addEventListener('invalid', function (e) {
  const campo = e.target.closest ? e.target : null;
  if (!campo || !campo.classList || !campo.classList.contains('product__personalization-input')) return;
  e.preventDefault(); /* niente fumetto nativo */

  campo.classList.add('product__personalization-input--errore');

  /* Solo il primo campo mancante guida scorrimento, focus e messaggio */
  if (!document.querySelector('[data-bdr-scroll-errore]')) {
    campo.setAttribute('data-bdr-scroll-errore', '');
    campo.scrollIntoView({ behavior: 'smooth', block: 'center' });
    campo.focus({ preventScroll: true });
    if (campo.form) bdrMostraErroreForm(campo.form, campo.closest('.product__personalization').dataset.msgObbligatori);
    setTimeout(function () { campo.removeAttribute('data-bdr-scroll-errore'); }, 600);
  }
}, true);

document.addEventListener('input', function (e) {
  const campo = e.target.closest ? e.target : null;
  if (!campo || !campo.classList || !campo.classList.contains('product__personalization-input')) return;
  if (campo.value.trim() !== '') {
    campo.classList.remove('product__personalization-input--errore');
    /* quando non resta nessun campo in errore, spegne anche il messaggio */
    if (campo.form && !document.querySelector('.product__personalization-input--errore')) {
      bdrNascondiErroreForm(campo.form);
    }
  }
});

/* --------------------------------------------------------------------------
   Campi legati alla variante scelta
   Alcuni articoli vendono la stessa misura in due versioni, per esempio
   "S" e "S con nome" sugli adesivi IKEA. Il campo del nome deve comparire
   solo sulla seconda, e diventare obbligatorio soltanto quando è visibile.
   -------------------------------------------------------------------------- */
(function () {
  function titoloVarianteCorrente(radice) {
    // si guardano prima i controlli, perché sono l'unica fonte che segue i clic:
    // il JSON stampato dal server resta fermo alla variante di partenza
    const scelte = [];
    radice.querySelectorAll('.product-form__input input[type="radio"]:checked').forEach((r) => scelte.push(r.value));
    radice.querySelectorAll('.product-form__input select').forEach((s) => scelte.push(s.value));
    if (scelte.length) return scelte.join(' / ').toLowerCase();

    const dati = radice.querySelector('script[id^="BdrSelectedVariant"]');
    if (dati) {
      try {
        const v = JSON.parse(dati.textContent);
        if (v && v.title) return String(v.title).toLowerCase();
      } catch (e) {
        /* dato non leggibile: si resta senza titolo */
      }
    }
    return '';
  }

  function aggiorna(radice) {
    const campi = radice.querySelectorAll('.product__personalization-field[data-condizione]');
    if (!campi.length) return;
    const titolo = titoloVarianteCorrente(radice);
    campi.forEach((campo) => {
      const atteso = campo.dataset.condizione;
      const mostra = titolo.indexOf(atteso) !== -1;
      campo.classList.toggle('product__personalization-field--nascosto', !mostra);
      campo.querySelectorAll('input[data-obbligatorio], textarea[data-obbligatorio]').forEach((input) => {
        if (mostra) {
          input.setAttribute('required', 'required');
        } else {
          input.removeAttribute('required');
          input.value = '';
        }
      });
      campo.querySelectorAll('.bdr-color-picker[data-required]').forEach((picker) => {
        picker.classList.toggle('bdr-color-picker--inattivo', !mostra);
      });
    });
  }

  function radiceProdotto(nodo) {
    return nodo.closest('product-info') || nodo.closest('.bdr-product__info') || document;
  }

  document.addEventListener('change', function (e) {
    if (e.target.closest('.product-form__input')) aggiorna(radiceProdotto(e.target));
  });

  // il cambio variante ridisegna il prezzo: si riallinea anche dopo l'aggiornamento AJAX
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('product-info, .bdr-product__info').forEach(aggiorna);
  });
  document.addEventListener('shopify:section:load', function () {
    document.querySelectorAll('product-info, .bdr-product__info').forEach(aggiorna);
  });
})();
